import { render, staticRenderFns } from "./CandidatureListItem.vue?vue&type=template&id=8c08b098&"
import script from "./CandidatureListItem.vue?vue&type=script&lang=js&"
export * from "./CandidatureListItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidatureListItem.vue?vue&type=style&index=0&id=8c08b098&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports